import React, { useState } from 'react'
import { PersistentNotification } from '@reapitform/common-ui'
import { SectionTile } from '@reapitform/dashboard-ui'
import { useAgentContactDetails } from '../../../../api/agent-settings'
import ContactDetailsDisplayView from './display-view'
import ContactDetailsDisplayViewLoading from './display-view/loader'
import ContactDetailsEditForm from './edit-form'

const ContactDetailsSection: React.FC = () => {
  const [isEdited, setIsEdited] = useState(false)
  const { data, loading, queryKey, errorString, isRefetching } = useAgentContactDetails()

  const handleActionClick = () => {
    if (loading) return

    setIsEdited(true)
  }

  const handleActionClose = () => setIsEdited(false)

  const shouldShowLoading: boolean = loading || isRefetching

  return (
    <SectionTile
      title="Contact Details"
      actionTitle={isEdited ? '' : 'Edit'}
      onActionClick={handleActionClick}
      disableMarginBottom
    >
      {shouldShowLoading && <ContactDetailsDisplayViewLoading />}
      {!shouldShowLoading && isEdited && (
        <ContactDetailsEditForm
          onClose={handleActionClose}
          onSuccess={handleActionClose}
          queryKey={queryKey}
          defaultData={data ?? undefined}
        />
      )}
      {!shouldShowLoading && !isEdited && <ContactDetailsDisplayView data={data} />}
      {errorString && (
        <PersistentNotification isFullWidth isExpanded isInline intent="danger">
          Failed to load contact details information, try refreshing your page.
        </PersistentNotification>
      )}
    </SectionTile>
  )
}

export default ContactDetailsSection
